import { Modal, Typography } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface DeleteConfirmationModalProps {
  visible: boolean;
  onDelete: () => Promise<void>;
  onCancel: () => void;
}

const DeleteConfirmationModal = (props: DeleteConfirmationModalProps) => {
  const { t } = useTranslation('common');
  const { visible, onDelete, onCancel } = props;
  return (
    <Modal
      title={t('delete.confirmation.modal.title')}
      visible={visible}
      onOk={onDelete}
      onCancel={onCancel}
      okText={t('delete.confirmation.modal.okText')}
      cancelText={t('delete.confirmation.modal.cancelText')}
      centered
    >
      <StyledDiv>
        <p>{t('delete.confirmation.modal.description')}</p>
      </StyledDiv>
    </Modal>
  );
};

const StyledDiv = styled.div`

`

export default DeleteConfirmationModal;